import React from 'react';
import {Styles} from '../../../config/design/styles';
import FileManager from "./FileManager";
import AppAnimate from "../../components/AppAnimate";
import Grid from "@mui/material/Grid2";
import AppCard from "../../components/layout/components/AppCard";
import {withStyles} from "@mui/styles";
import {translateKey} from "../../../config/values";
import Title from "../../components/elements/Title";
class FileManagerPage extends React.Component {
    classes = this.props.classes;
    render(){
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={translateKey('fileManager')}>
                <Grid container spacing={2} justify="center">
                    <Grid item size={12}>
                        <Title align="left" color="text">{translateKey('fileManager')}</Title>
                    </Grid>
                    <Grid item size={12} >
                        <FileManager fileType="all" page/>
                    </Grid>
                </Grid>
            </AppAnimate>
        );
    }
}
export default withStyles(Styles)(FileManagerPage);
